export default fields => {
  let errors = {};
  const { newCorrection } = fields;
  if (!newCorrection) {
    errors.newCorrection = "You must fill correction's number";
  }
  return errors;
};
